export default __webpack_public_path__ + "static/media/Dr._Jane_Thomason_AHV_In_Moms_We_Trust.2f5a721b.jpg";